import styled from '@emotion/styled'
import Img from 'gatsby-image'
import Title from 'components/Utilities/Title'
import Text from 'components/Utilities/Text'

export const ContactMainContainer = styled.div``

export const ContactContainer = styled.div`
  @media (min-width: ${props => props.theme.breakpoints.md}) {
    display: flex;
    align-items: flex-start;
    flex-direction: ${props => (props.reverseOrder ? 'row-reverse' : 'row')};
  }
`

export const ContactImageContainer = styled.div`
  width: calc(100vw - 40px);
  height: 280px;
  margin: 40px 0 15px;

  @media (min-width: ${props => props.theme.breakpoints.md}) {
    width: 530px;
    height: 530px;
  }
`

export const ContactImage = styled(Img)`
  width: 100%;
  height: 100%;
`

export const ContactContent = styled.div`
  @media (min-width: ${props => props.theme.breakpoints.md}) {
    margin-left: 30px;
    margin-top: 10%;
  }
`

export const ContactTitle = styled(Title)`
  font-weight: 200;

  @media (max-width: ${props => props.theme.breakpoints.md}) {
    font-size: ${props => props.theme.fonts.xl_small};
    padding-bottom: 15px;
  }

  @media (min-width: ${props => props.theme.breakpoints.md}) {
    max-width: 400px;
    margin-left: ${props => (props.reverseOrder ? 'unset' : '-150px')};
    margin-right: ${props => (props.reverseOrder ? '-150px' : 'unset')};
    padding-bottom: 30px;
  }
`

export const ContactAddress = styled(Text)`
  p {
    margin-bottom: 0px;
    font-weight: 200;
    line-height: 1.56;
  }

  @media (min-width: ${props => props.theme.breakpoints.md}) {
    max-width: 400px;
    margin-right: ${props => (props.reverseOrder ? '30px' : 'unset')};
  }
`

export const ContactTelephone = styled(Text)`
  a {
    text-decoration: none;
    color: ${props => props.theme.colors.primarygreen};
    font-weight: 200;
    font-size: ${props => props.theme.fonts.xxs};

    @media (min-width: ${props => props.theme.breakpoints.md}) {
      font-size: ${props => props.theme.fonts.m};
    }
  }
`
